import React from "react";
import ReactDOM from "react-dom";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { msalConfig } from "./configs/MsalConfig";
import "./index.css";

if (process.env.NODE_ENV === "development") {
  const resizeObserverErrors = [
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop limit exceeded",
  ];

  const isResizeObserverError = (message) =>
    typeof message === "string" &&
    resizeObserverErrors.some((errorText) => message.includes(errorText));

  const getErrorMessage = (event) => {
    if (!event) {
      return "";
    }

    if (typeof event.message === "string") {
      return event.message;
    }

    if (typeof event.error?.message === "string") {
      return event.error.message;
    }

    return "";
  };

  const suppressResizeObserverError = (event) => {
    const message = getErrorMessage(event);
    if (!isResizeObserverError(message)) {
      return;
    }

    if (typeof event.preventDefault === "function") {
      event.preventDefault();
    }
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
  };

  // Captura temprana para evitar que CRA lo tome como runtime error fatal.
  window.addEventListener("error", suppressResizeObserverError, true);

  window.onerror = (message) => {
    if (isResizeObserverError(message)) {
      return true;
    }

    return false;
  };

  window.addEventListener("unhandledrejection", (event) => {
    const reasonMessage =
      typeof event?.reason === "string"
        ? event.reason
        : event?.reason?.message;

    if (isResizeObserverError(reasonMessage)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const originalConsoleError = console.error;
  console.error = (...args) => {
    const hasResizeObserverError = args.some((arg) => {
      if (typeof arg === "string") {
        return isResizeObserverError(arg);
      }

      if (arg && typeof arg.message === "string") {
        return isResizeObserverError(arg.message);
      }

      return false;
    });

    if (hasResizeObserverError) {
      return;
    }

    originalConsoleError(...args);
  };
}


const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.handleRedirectPromise().catch(() => null);
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const existingAccounts = msalInstance.getAllAccounts();
if (existingAccounts.length > 0) {
  msalInstance.setActiveAccount(existingAccounts[0]);
}

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
